/**
 * Tiny class-name joiner. If your app already has shadcn's `cn`
 * (clsx + tailwind-merge) at "@/lib/utils", delete this file and
 * change the imports in the components to point there instead.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(" ");
}
